import { render, staticRenderFns } from "./bindStatus.vue?vue&type=template&id=5ce84168&scoped=true&"
import script from "./bindStatus.vue?vue&type=script&lang=js&"
export * from "./bindStatus.vue?vue&type=script&lang=js&"
import style0 from "./bindStatus.vue?vue&type=style&index=0&id=5ce84168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce84168",
  null
  
)

export default component.exports